const messages = {
  ua: {
    logo: require('../assets/img/logo-main.png'),
    preloader: {
      title: 'Готуємось<br> до запуску'
    },
    start: {
      title: 'Допоможи Ілону<br> КЛІМАТИЗУВАТИ',
      button: 'ПОЛЕТІЛИ!',
      marsImage: require('@/assets/img/mars.svg'),
      text1: 'Коли плануєш переїзд, не важливо<br> чи це облаштування нової оселі,<br> або взагалі переїзд на іншу<br class="not-sensor-panel-br"> планету,<br class="sensor-panel-br"> головне — це клімат',
      text2: 'Тому для кліматизації Марсу<br class="not-sensor-panel-br"> ми<br class="sensor-panel-br"> відібрали найкращу техніку Daikin,<br> яка допоможе перетворити планету',
      button2: 'Кліматизувати'
    },
    temperature: {
      title: 'Середня температура на Марсі <span class="font-unicase">-63°C</span>',
      text: 'Скористайся розумним режимом<br> підігріву кондиціонеру Stylish',
      button: 'Підігріти планету'
    },
    temperatureIncrease: {
      title: 'Ще доволі прохолодно.<br> Налаштуй температуру',
      titleReady: 'Чудово!<br/> Вже тепліше!'
    },
    humidity: {
      title: 'На Марсі вже тепліше,<br> але атмосфера все ще доволі суха',
      title2: 'Тут нам в нагоді — режим зволоження<br> від кондиціонеру Ururu Sarara',
      button: 'Увімкнути зволоження'
    },
    humidityIncrease: {
      title: 'Режим Humidity підбере<br> рівень зволоження повітря',
      titleReady: 'Чудово, утворюються<br> дощові хмари!'
    },
    cleaningAir: {
      title: 'На Марсі пішов дощ, підіймається пил',
      title2: 'Налаштуйте очищення повітря<br> з технологією Streamer Purify',
      button: 'Очистити повітря'
    },
    increasePower: {
      title: 'Збільште рівень<br class="not-sensor-panel-br"> потужності',
      titleReady: 'Кліматизацію<br class="not-sensor-panel-br"> майже заверешено!'
    },
    climateControl: {
      title: 'Залишилось стабілізувати атмосферу<br> та включити клімат-контроль',
      title2: 'В цьому нам допоможе<br> функція кондиціонеру Sensira',
      button: 'Увімкнути<br> клімат-контроль'
    },
    endTerraform: {
      title: 'Ілон в захваті! Наша <br class="not-sensor-panel-br"> нова домівка<br class="sensor-panel-br"> вже <br class="not-sensor-panel-br">готова до заселення!',
      title2: 'Переглянь кліматичну<br class="not-sensor-panel-br"> техніку,<br class="sensor-panel-br"> яка стала в нагоді',
      button: 'Переглянути',
      share: 'Поділитись'
    },
    products: {
      title: 'Кондиціонери<br> та очисники повітря Daikin',
      button: 'На початок'
    },
    share: {
      title: 'Давайте допоможемо Ілону кліматизувати Марс за допомогою Daikin!',
      text: 'Переходьте за посиланням і проходьте всі етапи кліматизації Марса з Daikin..'
    }
  },

  en: {
    logo: require('../assets/img/logo-main-en.png'),
    preloader: {
      title: 'Getting ready<br> for the launch'
    },
    start: {
      title: 'Help Elon<br>to CLIMATIZE',
      button: 'LET\'S GO!',
      marsImage: require('@/assets/img/mars-en.svg'),
      text1: 'When you\'re planning to move, it does not<br> matter whether you\'re moving to a new home<br> or another planet; the main thing is the climate.',
      text2: 'Therefore, we have selected the best Daikin<br/> technology for climatizing Mars to help<br> transform the planet.',
      button2: 'CLIMATIZE NOW'
    },
    temperature: {
      title: 'It\'s <span class="font-unicase">-63 °C</span> on Mars now',
      text: 'Use the heating mode<br> of the Stylish air conditioner',
      button: 'HEAT THE PLANET'
    },
    temperatureIncrease: {
      title: 'It\'s still pretty cold.<br> Adjust the temperature',
      titleReady: 'Perfect!<br/>  It\'s getting warmer!'
    },
    humidity: {
      title: 'It\'s getting warmer on Mars,<br> but the atmosphere is still quite dry',
      title2: 'What we need — humidification mode<br> from the Ururu Sarara air conditioner',
      button: 'TURN ON HUMIDIFICATION'
    },
    humidityIncrease: {
      title: 'Select the level of humidity',
      titleReady: 'Great, clouds<br> are formed!'
    },
    cleaningAir: {
      title: 'Now it\'s raining on Mars; dust is rising',
      title2: 'Purify the air with<br> Streamer Purify technology',
      button: 'Clean the air'
    },
    increasePower: {
      title: 'Increase the power',
      titleReady: 'Climatizing is <br class="not-sensor-panel-br">almost completed!'
    },
    climateControl: {
      title: 'To stabilize the atmosphere, we need<br> to turn on the climate control',
      title2: 'The Sensira air conditioner<br> function will help us with this',
      button: 'Turn on<br> climate control'
    },
    endTerraform: {
      title: 'Elon is charmed! <br class="not-sensor-panel-br"> Our new home <br>is ready to move in!',
      title2: 'Take a look at the climatic<br class="not-sensor-panel-br"> appliances <br class="sensor-panel-br"> that came in handy',
      button: 'Preview',
      share: 'Share'
    },
    products: {
      title: 'Daikin air conditioners<br> and air purifiers',
      button: 'To the start'
    },
    share: {
      title: 'Let\'s help Elon climatize Mars with Daikin!',
      text: 'Follow the link and go through all the stages of climatization of Mars with Daikin.'
    }
  }
}

export default messages
